module.exports = __webpack_public_path__ + "img/article-card1.3fead00b.png";